import { NgModule }            from '@angular/core';
import { FormSwitchComponent } from '@app/shared/form-elements/form-switch/form-switch.component';
import { FormElementsModule }  from '@shared/form-elements/form-elements.module';
import { UiSwitchModule }      from 'ngx-ui-switch';

@NgModule( {
	declarations: [
		FormSwitchComponent
	],
	imports: [
		FormElementsModule,
		UiSwitchModule
	],
	exports: [
		FormSwitchComponent
	]
} )
export class FormSwitchModule {}
